// PostList.js
import { Grid, Box, Typography, Card, CardActionArea, CardMedia, CardContent, Button, Stack, } from '@mui/material';
import { ThemeProvider,  } from '@mui/material/styles';
import { lightTheme } from '../components/themes/main_theme.js';
import Header from '../components/menu/Header.tsx';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useNewsletters } from '../data/cms.ts';

const CardStack = ({ image, description, url }: { image: string, description: string, url: string }) => (
  // Matches the home page card: image first, equal heights across the row.
  <Grid item xs={12} sm={6} md={4} lg={3} sx={{ display: 'flex' }}>
    <CardActionArea
      onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
      sx={{
        height: '100%',
        borderRadius: 5,
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': { transform: 'translateY(-4px)', boxShadow: 6 },
      }}
    >
      <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', bgcolor: 'background.paper', p: 1.5 }}>
        <CardMedia
          component="img"
          image={image}
          sx={{ width: '100%', aspectRatio: '4 / 3', objectFit: 'cover', borderRadius: 3 }}
        />
        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', py: 1.5, px: 0.5 }}>
          <Typography variant="h6" color="primary" align="center" sx={{ fontSize: '1.05rem', lineHeight: 1.35 }}>
            {description}
          </Typography>
        </Box>
      </Card>
    </CardActionArea>
  </Grid>
);

const NewsList = () => {
  const { items: newsletters } = useNewsletters();

  return (
  <ThemeProvider theme={lightTheme}>
    <Stack direction={"row"} justifyContent="space-between" alignItems="center">
        <Header name={'NEWS'} /> 
        <Box display="flex" justifyContent="center" alignItems="center" sx={{ mt: {xs: 3, md: 5}}}>
          <Button variant="contained" startIcon={<NotificationsIcon />} sx={{ borderRadius: 3, px: 3, py: 1, fontWeight: 700 }}
            onClick={() => window.open('http://eepurl.com/ilnCGv', '_blank')}>
            Subscribe
          </Button>
        </Box>
    </Stack>
    {/* 40px side margins ate a quarter of a phone screen; scale them down. */}
    <Box mx={{ xs: 2, sm: 3, md: 5 }} mt={3}>
      <Grid container spacing={3} alignItems="stretch">
        {newsletters.map((item, idx) => (
          <CardStack
            key={idx}
            url={item.url}
            description={item.description}
            image={item.image}
          />
        ))}
      </Grid>
    </Box>
  </ThemeProvider>
  );
};

export default NewsList;